import { render, staticRenderFns } from "./BrandedModal.vue?vue&type=template&id=03dc88d1&scoped=true"
import script from "./BrandedModal.vue?vue&type=script&lang=js"
export * from "./BrandedModal.vue?vue&type=script&lang=js"
import style0 from "./BrandedModal.vue?vue&type=style&index=0&id=03dc88d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc88d1",
  null
  
)

export default component.exports